export default __webpack_public_path__ + "static/media/timeup_workshop.c19d544e.svg";